import { render, staticRenderFns } from "./knowledge-points.vue?vue&type=template&id=3ed685e8"
import script from "./knowledge-points.vue?vue&type=script&lang=js"
export * from "./knowledge-points.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports